import {
	ParentStateActions,
	ParentStateActionTypes
} from "@/ProposalBuilder/store/actions/Parent";
import { Document } from "@/Contracts/Documents";
import { Template } from "@/Contracts/Templates";
import { TaxCategory, TaxRegion } from "@/Contracts/Users";
import { VendorTemplateDetail } from "@/Contracts/Vendor/Templates";
import { Reducer } from "redux";

export interface ParentState {
	readonly currentActiveDocument: Document | null;
	readonly currentActiveTemplate: Template | VendorTemplateDetail | null;
	readonly taxCategoriesList: TaxCategory[];
	readonly taxRegionsList: TaxRegion[];
}

export const initialParentState: ParentState = {
	currentActiveDocument: null,
	currentActiveTemplate: null,
	taxCategoriesList: new Array<TaxCategory>(),
	taxRegionsList: new Array<TaxRegion>()
};

const ParentStateReducer: Reducer<ParentState, ParentStateActions> = (
	state: ParentState = initialParentState,
	action: ParentStateActions
): ParentState => {
	switch (action.type) {
		case ParentStateActionTypes.UPDATE_PARENT_STATE: {
			return {
				...state,
				...action.parentState
			};
		}
		case ParentStateActionTypes.UPDATE_CURRENT_ACTIVE_DOCUMENT: {
			return {
				...state,
				currentActiveDocument: action.currentActiveDocument
			};
		}
		case ParentStateActionTypes.UPDATE_CURRENT_ACTIVE_TEMPLATE: {
			return {
				...state,
				currentActiveTemplate: action.currentActiveTemplate
			};
		}
		case ParentStateActionTypes.UPDATE_CURRENT_DOC_PAYMENT_SUMMARY_SUCCESSFUL: {
			const currentActiveDocument = state.currentActiveDocument
				? { ...state.currentActiveDocument }
				: null;
			if (!action.paymentSummary || !currentActiveDocument) {
				return {
					...state
				};
			}
			const {
				total,
				total_adjustment_fees,
				total_discount,
				total_tax,
				commission,
				margin,
				margin_percentage
			} = action.paymentSummary;

			currentActiveDocument.total_discount = total_discount;
			currentActiveDocument.commission = commission as number | undefined;
			currentActiveDocument.total_tax = total_tax;
			if (currentActiveDocument.revisions?.length) {
				if (total !== null) {
					const newTotal = { ...total };

					newTotal.margin_percentage = margin_percentage ?? 0;
					newTotal.margin_value = margin ?? 0;

					currentActiveDocument.revisions[0].total = newTotal;
				} else
					currentActiveDocument.revisions[0].total =
						total ?? undefined;
			}
			if (currentActiveDocument.payment) {
				currentActiveDocument.payment.payment_options =
					total_adjustment_fees ?? undefined;
			}
			return {
				...state,
				currentActiveDocument: currentActiveDocument
			};
		}
		default: {
			return state;
		}
	}
};

export default ParentStateReducer;
